import template from "./app-language-selector.html";

const AppLanguageSelectorComponent = {
  bindings: {
    defaultValue: "<",
    onChange: "&",
  },
  template: template,
  controller: class AppLanguageController {
    /* @ngInject */
    constructor($scope, appLanguages) {
      this.$scope = $scope;
      this.appLanguages = appLanguages;
    }

    $onInit() {
      this.appLanguage = this.defaultValue;
      this.$scope.$watch(
        () => this.appLanguage,
        (newVal, oldVal) => {
          if (!angular.equals(newVal, oldVal))
            this.onChange({
              oldAppLanguage: oldVal,
              newAppLanguage: this.appLanguage,
            });
        }
      );
    }

    $onChanges(changesObj) {
      if (changesObj.defaultValue && !changesObj.defaultValue.isFirstChange())
        this.appLanguage = this.defaultValue;
    }
  },
};

export default AppLanguageSelectorComponent;
